// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.date-range-selector {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  float: right;
  width: 50%;
  justify-content: flex-end;
}
.date-range-selector .date-select-lbl {
  white-space: nowrap;
}

/*@media only screen and (max-width: 576px) {
    .date-range-selector {
        width: 100%;
        justify-content: flex-start;
    }
}*/
.rdrDefinedRangesWrapper {
  border: none;
  width: auto;
  display: flex;
  align-items: center;
}

.rdrStaticRange {
  font-size: 14px;
  border: none;
  font-weight: 600;
  color: #525564;
  margin-right: 12px;
  white-space: nowrap;
}

.rdrStaticRange:hover .rdrStaticRangeLabel {
  background-color: #eeeeef;
}

.rdrStaticRangeLabel {
  padding: 9px 12px;
  border-radius: 18px;
}

.rdrDefinedRangesWrapper .rdrStaticRangeSelected {
  background-color: #e0f3ff;
  border-radius: 18px;
  color: #0069d1 !important;
}

.rdrStaticRanges-1 {
  flex-direction: initial;
}

.rdrStaticRanges {
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.rdrInputRanges  {
  display: none !important;
}

.rdrCalendarWrapper-hide {
  display: none;
}

.rdrCalendarWrapper-show {
  display: inline;
  display: initial;
}

.date-range-btn {
  padding: 9px 12px;
  border-radius: 18px;
  background-color: #fff;
  color: #525564;
  font-weight: 600;
  font-size: 14px;
  border: none;
}
.date-range-btn--selected {
  background-color: #e0f3ff;
}

.date-range-btn:hover {
  background-color: #eeeeef;
  cursor: pointer;
}

.rdrCalendarWrapper {
  position: absolute;
  top: 210px;
  z-index: 100;
  right: 120px;
}

.rdrCustomSelected {
  padding: 9px 12px;
  background-color: #e0f3ff;
  border-radius: 18px;
  color: #0069d1 !important;
}`, "",{"version":3,"sources":["webpack://./src/component/common/ZFDateRangePicker/ZFDateRangePicker.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACC,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AAED;AAAC;EACC,mBAAA;AAEF;;AAEA;;;;;EAAA;AAOA;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAAD;;AAGA;EACC,eAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAAD;;AAGA;EACC,yBAAA;AAAD;;AAGA;EACC,iBAAA;EACA,mBAAA;AAAD;;AAGA;EACC,yBAAA;EACA,mBAAA;EACA,yBAAA;AAAD;;AAGA;EACC,uBAAA;AAAD;;AAGA;EACC,mBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;AAAD;;AAGA;EACC,wBAAA;AAAD;;AAGA;EACC,aAAA;AAAD;;AAGA;EACC,eAAA;EAAA,gBAAA;AAAD;;AAGA;EACC,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAAD;AACC;EACC,yBAAA;AACF;;AAGA;EACC,yBAAA;EACA,eAAA;AAAD;;AAGA;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;AAAD;;AAGA;EACC,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AAAD","sourcesContent":[".date-range-selector {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tfloat: right;\n\twidth: 50%;\n\tjustify-content: flex-end;\n\n\t.date-select-lbl{\n\t\twhite-space: nowrap;\n\t}\n}\n\n/*@media only screen and (max-width: 576px) {\n    .date-range-selector {\n        width: 100%;\n        justify-content: flex-start;\n    }\n}*/\n\n.rdrDefinedRangesWrapper {\n\tborder: none;\n\twidth: auto;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.rdrStaticRange {\n\tfont-size: 14px;\n\tborder: none;\n\tfont-weight: 600;\n\tcolor: #525564;\n\tmargin-right: 12px;\n\twhite-space: nowrap;\n}\n\n.rdrStaticRange:hover .rdrStaticRangeLabel {\n\tbackground-color: #eeeeef;\n}\n\n.rdrStaticRangeLabel {\n\tpadding: 9px 12px;\n\tborder-radius: 18px;\n}\n\n.rdrDefinedRangesWrapper .rdrStaticRangeSelected {\n\tbackground-color: #e0f3ff;\n\tborder-radius: 18px;\n\tcolor: #0069d1 !important;\n}\n\n.rdrStaticRanges-1 {\n\tflex-direction: initial;\n}\n\n.rdrStaticRanges {\n\tflex-direction: row;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: flex-end;\n}\n\n.rdrInputRanges  {\n\tdisplay: none !important;\n}\n\n.rdrCalendarWrapper-hide {\n\tdisplay: none;\n}\n\n.rdrCalendarWrapper-show {\n\tdisplay: initial;\n}\n\n.date-range-btn {\n\tpadding: 9px 12px;\n\tborder-radius: 18px;\n\tbackground-color: #fff;\n\tcolor: #525564;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tborder: none;\n\t&--selected {\n\t\tbackground-color: #e0f3ff;\n\t}\n}\n\n.date-range-btn:hover {\n\tbackground-color: #eeeeef;\n\tcursor: pointer;\n}\n\n.rdrCalendarWrapper {\n\tposition: absolute;\n\ttop: 210px;\n\tz-index: 100;\n\tright: 120px;\n}\n\n.rdrCustomSelected {\n\tpadding: 9px 12px;\n\tbackground-color: #e0f3ff;\n\tborder-radius: 18px;\n\tcolor: #0069d1 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
